// extracted by mini-css-extract-plugin
export default {"icon__bottom":"IconBottom_icon__bottom__0QG9O"};